import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { StyledButton } from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { groupInfosAtom, isPendingTabulationAtom } from '../atoms'

export const ClearGroupsButton = () => {
  const { t } = useTranslation()
  const logEvent = useLogEvent()

  const setGroupInfos = useSetAtom(groupInfosAtom)
  const setIsPendingTabulation = useSetAtom(isPendingTabulationAtom)

  const handleSelectedGroupIndexReset = React.useCallback(() => {
    setGroupInfos([])
    setIsPendingTabulation(true)

    logEvent('Reset overlap segment selection')
  }, [logEvent, setGroupInfos, setIsPendingTabulation])

  return (
    <StyledButton onClick={handleSelectedGroupIndexReset}>
      {t('clear_all')}
    </StyledButton>
  )
}
